import Breadcrumbs from "../../../components/BreadCrumbs/Breadcrumbs"
import Button from "../../../components/Button/Button"
import PlusIcon from "../../../assets/images/icons/PlusIcon.svg"
import React, { useEffect, useState } from "react"
import ContactGroupsTable from './ContactGroupsTable'
import { useDispatch } from "react-redux"
import { useMyContextLoading } from "../../../components/LoadingContextProvider/LoadingContextProvider"
import { fetchContactGroups } from "../../../features/contactGroups/contactGroups"
import { showSnackBar } from "../../../components/Snackbar/Snackbar"
import { useNavigate } from "react-router-dom"
import { TABLE_CARD } from "../../../components/Table/tableCardClass"

const ContactGroups = ({ userId }) => {
  const dispatch = useDispatch()
  const { triggerBar } = useMyContextLoading()
  const [isUpdated, setIsUpdated] = useState(false)
  const [showAddGroup, setShowAddGroup] = useState(false)
  const [contactGroups, setContactGroups] = useState([])

  const BreadcrumbsTitleActive = ["Settings"]
  const BreadcrumbsTitle = ["Contact Groups"]
  const navigate = useNavigate()


  const handleBreadcrumbClick = () => {
    setShowAddGroup(false)
  }

  const getContactGroups = async () => {
    triggerBar(true)
    try {
      const response = await dispatch(fetchContactGroups())
      setContactGroups(response?.payload?.data ?? [])
    } catch (error) {
      showSnackBar("error", error)
      console.error('An unexpected error occurred:', error)
    }
    triggerBar(false)
  }

  useEffect(() => {
    getContactGroups()
  }, [])

  useEffect(() => {
    getContactGroups()
  }, [isUpdated])

  return (
    <div>
      <>
        <div className="flex justify-between">
          <div>
            <h1 className="font-bold text-xl mb-2 w-full">
              Contact Groups
            </h1>
            <Breadcrumbs
              title={BreadcrumbsTitle}
              titleActive={BreadcrumbsTitleActive}
              onBreadcrumbClick={handleBreadcrumbClick}
            />
          </div>
          <div className="flex pr-[40px] items-center">
            <Button classes="flex h-9 items-center" onClick={() => navigate("/contact-groups/add", {
              replace: true,
              state: { isCreate: true }
            })}>
              <span className="flex items-center gap-2">
                <img src={PlusIcon} alt="plus"/>
                <span>Add Group</span>
              </span>
            </Button>
          </div>
        </div>
        <div className={`${TABLE_CARD} mt-6`}>
          <ContactGroupsTable
            data={contactGroups}
            setIsUpdated={setIsUpdated}
            isUpdated={isUpdated}
          />
        </div>
      </>
    </div>
  )
}

export default ContactGroups
